import { CurrencyPipe } from '@angular/common';
import { LabelValueModel } from '../models';
import { CURRENTYEAR } from '../models/data/currentYear';

export class SurveyHelper {

  private static cp = new CurrencyPipe('en-US');

  public static getSurveyFieldList(survey: any) {
    return Object.keys(survey.attributes).map(key => {
      return new LabelValueModel({
        field: key,
        value: survey.attributes[key]
      });
    });
  }

  public static toSearchCardResultList(survey: LabelValueModel[], isExpanded: boolean, dashboard?: boolean) {
    const surveyFields = {
      'field_program_best_described_as': survey.find(f => f.field === 'field_program_best_described_as'),
      'field_accepting_current_year': survey.find(f => f.field === 'field_accepting_current_year'),
      'field_accepting_next_year': survey.find(f => f.field === 'field_accepting_next_year'),
      'field_program_size': survey.find(f => f.field === 'field_program_size'),
      'field_participates_in_eras': survey.find(f => f.field === 'field_participates_in_eras'),
      'field_match_nrmp_main': survey.find(f => f.field === 'field_match_nrmp_main'),
      'field_match_nrmp_adv_fellow': survey.find(f => f.field === 'field_match_nrmp_adv_fellow'),
      'field_program_type': survey.find(f => f.field === 'field_program_type'),
      'field_interviews_conducted': survey.find(f => f.field === 'field_interviews_conducted'),
      'field_avg_hours_on_duty_y1': survey.find(f => f.field === 'field_avg_hours_on_duty_y1'),
      'field_pct_img': survey.find(f => f.field === 'field_pct_img'),
      'field_pct_do': survey.find(f => f.field === 'field_pct_do'),
      'field_pct_usmd': survey.find(f => f.field === 'field_pct_usmd'),
    };

    // Sparse fieldsets can remove a survey field from response, so always check it exists first then has value.
    const programDetails = [];
    const firstYearPositions = surveyFields.field_program_size ? surveyFields.field_program_size.value[0] : false;

    if (surveyFields.field_program_best_described_as && surveyFields.field_program_best_described_as.value) {
      programDetails.push(surveyFields.field_program_best_described_as.value);
    }

    if (surveyFields.field_accepting_current_year && surveyFields.field_accepting_current_year.value) {
      programDetails.push('Accepting applications');
    }

    if (firstYearPositions) {
      programDetails.push(firstYearPositions + ' first year positions');
    }

    if (surveyFields.field_interviews_conducted && surveyFields.field_interviews_conducted.value) {
      programDetails.push(surveyFields.field_interviews_conducted.value + ' Interviews conducted last year for first year positions');
    }

    if (surveyFields.field_avg_hours_on_duty_y1 && surveyFields.field_avg_hours_on_duty_y1.value) {
      programDetails.push(surveyFields.field_avg_hours_on_duty_y1.value + ' avg hours on duty per week');
    }

    if (surveyFields.field_pct_img && surveyFields.field_pct_img.value) {
      programDetails.push(surveyFields.field_pct_img.value + '% IMG');
    }

    if (surveyFields.field_pct_do && surveyFields.field_pct_do.value) {
      programDetails.push(surveyFields.field_pct_do.value + '% DO');
    }

    if (surveyFields.field_pct_usmd && surveyFields.field_pct_usmd.value) {
      programDetails.push(surveyFields.field_pct_usmd.value + '% USMD');
    }

    return programDetails;
  }

  public static toDashboardCardResultList(survey: LabelValueModel[], summary = false) {
    const nowYear = CURRENTYEAR;
    const currentYearText = `'${(nowYear +1).toString().substring(2)}-'${(nowYear + 2).toString().substring(2)}`;
    const nextYearText = `'${(nowYear + 2).toString().substring(2)}-'${(nowYear + 3).toString().substring(2)}`;
    const searchResultCardFields = {
      'field_accepting_current_year': survey.find(f => f.field === 'field_accepting_current_year'),
      'field_accepting_next_year': survey.find(f => f.field === 'field_accepting_next_year'),
      'field_interviews_conducted': survey.find(f => f.field === 'field_interviews_conducted'),
      'field_avg_hours_on_duty_y1': survey.find(f => f.field === 'field_avg_hours_on_duty_y1'),
      'field_usmle_step_1_required': survey.find(f => f.field === 'field_usmle_step_1_required'),
      'field_usmle_step_1_minimum_score': survey.find(f => f.field === 'field_usmle_step_1_minimum_score'),
      'field_comlex_level_1': survey.find(f => f.field === 'field_comlex_level_1'),
      'field_comlex_level_1_score': survey.find(f => f.field === 'field_comlex_level_1_score'),
      'field_graduate_year_statistics': survey.find(f => f.field === 'field_graduate_year_statistics'),
      'field_program_size': survey.find(f => f.field === 'field_program_size'),
      'field_program_best_described_as': survey.find(f => f.field === 'field_program_best_described_as'),
      'field_first_year_salary': survey.find(f => f.field === 'field_first_year_salary'),
    };


    const programDetails = [];


    if (summary) {
      programDetails.push(searchResultCardFields.field_program_best_described_as && searchResultCardFields.field_program_best_described_as.value !== null && searchResultCardFields.field_program_best_described_as.value.length > 0 ? searchResultCardFields.field_program_best_described_as.value : '');
      programDetails.push(searchResultCardFields.field_program_size && searchResultCardFields.field_program_size.value !== null && searchResultCardFields.field_program_size.value.length > 0 ? `${searchResultCardFields.field_program_size.value[0]} first year positions` : '');
      programDetails.push(searchResultCardFields.field_interviews_conducted && searchResultCardFields.field_interviews_conducted.value !== null && searchResultCardFields.field_interviews_conducted.value.length > 0 ? `${searchResultCardFields.field_interviews_conducted.value} interviews` : '');
      programDetails.push(searchResultCardFields.field_accepting_current_year && searchResultCardFields.field_accepting_current_year.value !== null && searchResultCardFields.field_accepting_current_year.value ? `Accepting applications ${currentYearText}` : ''); // accepting current year
      programDetails.push(searchResultCardFields.field_accepting_next_year && searchResultCardFields.field_accepting_next_year.value !== null && searchResultCardFields.field_accepting_next_year.value ? `Will be accepting applications ${nextYearText}` : ''); // accepting next year
      programDetails.push(searchResultCardFields.field_first_year_salary.value);
    } else {
      // Be sure to remove field_program_size from the count where only rows with a value greater than 0 gets included in the years length count
      let pgm_years = 0;
      if (searchResultCardFields.field_program_size && searchResultCardFields.field_program_size.value !== null ) {
        searchResultCardFields.field_program_size.value.filter( (pgm_year) => {
          if (pgm_year > 0) {
            pgm_years = pgm_years + 1;
          }
        });
      }

      let programDetailsLeft = [
        searchResultCardFields.field_accepting_current_year && searchResultCardFields.field_accepting_current_year.value ? `Accepting applications ${currentYearText}` : '', // accepting current year
        searchResultCardFields.field_accepting_next_year && searchResultCardFields.field_accepting_next_year.value ? `Will be accepting applications ${nextYearText}` : '', // accepting next year
        searchResultCardFields.field_interviews_conducted && searchResultCardFields.field_interviews_conducted.value !== null ? `${searchResultCardFields.field_interviews_conducted.value} interviews` : '',
        searchResultCardFields.field_avg_hours_on_duty_y1 && searchResultCardFields.field_avg_hours_on_duty_y1.value !== null ? `${searchResultCardFields.field_avg_hours_on_duty_y1.value} Avg number of hours/wk on duty` : '',
        searchResultCardFields.field_program_size && searchResultCardFields.field_program_size.value !== null && searchResultCardFields.field_program_size.value.length > 0 ? `${searchResultCardFields.field_program_size.value[0]} first year positions` : '',
        searchResultCardFields.field_program_size && searchResultCardFields.field_program_size.value !== null && searchResultCardFields.field_program_size.value.length > 0 ? `${pgm_years} years length` : ''
      ];

      programDetailsLeft = programDetailsLeft.filter(pd => pd !== null && pd !== undefined && pd !== '' && typeof(pd) !== undefined && pd.indexOf('null') < 0);

      let programDetailsRight = [
        searchResultCardFields.field_usmle_step_1_required && searchResultCardFields.field_usmle_step_1_required.value !== null ? (searchResultCardFields.field_usmle_step_1_required.value === true ? 'Step 1 Required' : '') : '',
        searchResultCardFields.field_usmle_step_1_minimum_score && searchResultCardFields.field_usmle_step_1_minimum_score.value !== null ? `Step 1 Min Score: ${searchResultCardFields.field_usmle_step_1_minimum_score.value}` : '',
        searchResultCardFields.field_comlex_level_1 && searchResultCardFields.field_comlex_level_1.value !== null && searchResultCardFields.field_comlex_level_1.value ? (searchResultCardFields.field_comlex_level_1.value === false || searchResultCardFields.field_comlex_level_1.value.toString().indexOf('No') > -1 ? '' : 'Level 1 Required') : '',
        searchResultCardFields.field_comlex_level_1_score && searchResultCardFields.field_comlex_level_1_score.value !== null ? `Level 1 Minimum Score: ${searchResultCardFields.field_comlex_level_1_score.value}` : '',
        searchResultCardFields.field_program_best_described_as && searchResultCardFields.field_program_best_described_as.value !== null ? searchResultCardFields.field_program_best_described_as.value : '',
        searchResultCardFields.field_first_year_salary && searchResultCardFields.field_first_year_salary.value !== null ? `First Year Salary: $${searchResultCardFields.field_first_year_salary.value}` : ''
      ];

      programDetailsRight = programDetailsRight.filter(pd => pd !== null && pd !== undefined && pd !== '' && typeof(pd) !== undefined && pd.indexOf('null') < 0);

      // Alternate details from the two arrays in order to get them to appear in the correct "column".
      for (let i = 0; i < Math.max(programDetailsLeft.length, programDetailsRight.length); i++) {
        if (i <= programDetailsLeft.length) {
          programDetails.push(programDetailsLeft[i]);
        } else {
          programDetails.push(' ');
        }

        if (i <= programDetailsRight.length) {
          programDetails.push(programDetailsRight[i]);
        } else {
          programDetails.push(' ');
        }
      }
    }
    return programDetails;
  }

  // FYS = first year salary
  public static findFYS(searchResultCardFields: any) {
    // if search result card fields exists and value length is greater than 0
    if (searchResultCardFields.field_graduate_year_statistics && searchResultCardFields.field_graduate_year_statistics.value !== null && searchResultCardFields.field_graduate_year_statistics.value.length > 0) {
      // variable to hold the index of the first year of salary
      // figure out the index of the first non-null item if it exists
      const salaryIndex = searchResultCardFields.field_graduate_year_statistics.value.findIndex(year => year.salary !== null);
      // if it does exist then return the string
      if (salaryIndex >= 0) {
        return `1st Year Salary: ${this.cp.transform(searchResultCardFields.field_graduate_year_statistics.value[salaryIndex].salary, 'USD')}`;
      }
    }
    // else it doesn't exist then return ''
    return '';
  }
}
